module.exports = __webpack_public_path__ + "img/1.ade98d7e.jpg";